/* =========================================================
   RICOJUNTO — Global JS
   Lenis (scroll suave) · GSAP reveal · Lucide · Cart drawer
   ========================================================= */
(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  // Lucide pode carregar depois; tenta renderizar quando disponível.
  function renderIcons() {
    if (window.lucide && typeof window.lucide.createIcons === "function") {
      window.lucide.createIcons();
      return true;
    }
    return false;
  }

  ready(function () {
    if (!renderIcons()) {
      var t = setInterval(function () {
        if (renderIcons()) clearInterval(t);
      }, 120);
      setTimeout(function () { clearInterval(t); }, 3000);
    }
    initSmoothScroll();
    initReveal();
    CartDrawer.init();
    NavDrawer.init();
    initMegaMenu();
    initHeaderSearch();
    initStickyHeader();
    Wishlist.init();
  });

  /* ---------- Busca expansível no header ---------- */
  function initHeaderSearch() {
    var panel = document.getElementById("HeaderSearch");
    if (!panel) return;
    var input = panel.querySelector("input[type='search']");
    document.querySelectorAll("[data-search-toggle]").forEach(function (b) {
      b.addEventListener("click", function () {
        var open = panel.classList.toggle("is-open");
        if (open && input) setTimeout(function () { input.focus(); }, 120);
      });
    });
    document.querySelectorAll("[data-search-close]").forEach(function (b) {
      b.addEventListener("click", function () { panel.classList.remove("is-open"); });
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") panel.classList.remove("is-open"); });
  }

  /* ---------- Header: encolher ao rolar + espaçamento dinâmico ---------- */
  function initStickyHeader() {
    var wrap = document.getElementById("HeaderWrap");
    if (!wrap) return;

    function setPad() {
      // usa a altura "cheia" (sem scroll) pra reservar espaço do conteúdo
      var wasScrolled = wrap.classList.contains("scrolled");
      wrap.classList.remove("scrolled");
      document.body.style.paddingTop = wrap.offsetHeight + "px";
      if (wasScrolled) wrap.classList.add("scrolled");
    }

    function onScroll() {
      if (window.scrollY > 24) wrap.classList.add("scrolled");
      else wrap.classList.remove("scrolled");
    }

    setPad();
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    var rt;
    window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(setPad, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(setPad);
  }

  /* ---------- Colapsa o menu se não couber ---------- */
  function initMegaMenu() {
    var cats = document.querySelector("[data-mega]");
    if (!cats) return;
    var btn = cats.querySelector("[data-mega-toggle]");
    if (btn) {
      btn.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = cats.classList.toggle("is-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }
    document.addEventListener("click", function (e) { if (!cats.contains(e.target)) cats.classList.remove("is-open"); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") cats.classList.remove("is-open"); });
  }

  /* ---------- Nav drawer (mobile) ---------- */
  var NavDrawer = {
    init: function () {
      this.drawer = document.getElementById("NavDrawer");
      this.overlay = document.getElementById("NavOverlay");
      if (!this.drawer) return;
      document.querySelectorAll("[data-nav-toggle]").forEach(function (b) {
        b.addEventListener("click", function () { NavDrawer.open(); });
      });
      document.querySelectorAll("[data-nav-close]").forEach(function (b) {
        b.addEventListener("click", function () { NavDrawer.close(); });
      });
      if (this.overlay) this.overlay.addEventListener("click", function () { NavDrawer.close(); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") NavDrawer.close(); });
    },
    open: function () {
      this.drawer.classList.add("is-open");
      if (this.overlay) this.overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
    },
    close: function () {
      this.drawer.classList.remove("is-open");
      if (this.overlay) this.overlay.classList.remove("is-open");
      document.body.style.overflow = "";
    }
  };
  window.NavDrawer = NavDrawer;

  /* ---------- Scroll suave (Lenis) ---------- */
  function initSmoothScroll() {
    if (!window.Lenis || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    // Scroll nativo no celular/touch — é mais rápido e responsivo lá.
    var isTouch = window.matchMedia("(hover: none)").matches || "ontouchstart" in window;
    if (isTouch) return;
    var lenis = new window.Lenis({
      duration: 0.8,
      lerp: 0.12,
      smoothWheel: true,
      syncTouch: false,
      wheelMultiplier: 1.1
    });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
    if (window.ScrollTrigger) {
      lenis.on("scroll", window.ScrollTrigger.update);
    }
    window.__lenis = lenis;
  }

  /* ---------- Animações de entrada (GSAP) ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!window.gsap || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      els.forEach(function (el) { el.style.opacity = 1; el.style.transform = "none"; });
      return;
    }
    if (window.ScrollTrigger) window.gsap.registerPlugin(window.ScrollTrigger);

    els.forEach(function (el, i) {
      var delay = parseFloat(el.getAttribute("data-reveal-delay")) || 0;
      window.gsap.to(el, {
        opacity: 1, y: 0, duration: 0.9, ease: "power3.out", delay: delay,
        scrollTrigger: window.ScrollTrigger ? { trigger: el, start: "top 88%" } : undefined
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  var CartDrawer = {
    init: function () {
      this.drawer = document.getElementById("CartDrawer");
      this.overlay = document.getElementById("CartOverlay");
      if (!this.drawer) return;

      document.querySelectorAll("[data-cart-open]").forEach(function (b) {
        b.addEventListener("click", function (e) { e.preventDefault(); CartDrawer.open(); });
      });
      document.querySelectorAll("[data-cart-close]").forEach(function (b) {
        b.addEventListener("click", function () { CartDrawer.close(); });
      });
      if (this.overlay) this.overlay.addEventListener("click", function () { CartDrawer.close(); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") CartDrawer.close(); });

      // Intercepta formulários de "adicionar ao carrinho".
      document.querySelectorAll("form[action$='/cart/add'], form[data-add-to-cart]").forEach(function (form) {
        form.addEventListener("submit", function (e) {
          e.preventDefault();
          CartDrawer.addFromForm(form);
        });
      });
    },

    open: function () {
      this.drawer.classList.add("is-open");
      if (this.overlay) this.overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
    },
    close: function () {
      this.drawer.classList.remove("is-open");
      if (this.overlay) this.overlay.classList.remove("is-open");
      document.body.style.overflow = "";
    },

    addFromForm: function (form) {
      var btn = form.querySelector("[type='submit']");
      var original = btn ? btn.innerHTML : "";
      if (btn) { btn.disabled = true; btn.innerHTML = "Adicionando..."; }

      fetch(window.theme.routes.cart_add_url + ".js", {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: new FormData(form)
      })
        .then(function (r) { return r.json(); })
        .then(function () { return CartDrawer.refresh(); })
        .then(function () { CartDrawer.open(); })
        .catch(function (err) { console.error("Erro ao adicionar ao carrinho", err); })
        .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
    },

    refresh: function () {
      return fetch(window.theme.routes.cart_url + "?section_id=cart-drawer")
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var fresh = doc.getElementById("CartDrawerContents");
          var current = document.getElementById("CartDrawerContents");
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var freshCount = doc.querySelector("[data-cart-count]");
          var count = freshCount ? freshCount.getAttribute("data-count") : "0";
          document.querySelectorAll("[data-cart-count]").forEach(function (el) {
            el.setAttribute("data-count", count);
            el.textContent = count;
            el.style.display = (count === "0" || count === "") ? "none" : "";
          });
          renderIcons();
        });
    }
  };

  window.CartDrawer = CartDrawer;

  /* ---------- Lista de desejos (localStorage) ---------- */
  var Wishlist = {
    key: "ricojunto_wishlist",
    read: function () { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    write: function (list) { localStorage.setItem(this.key, JSON.stringify(list)); },
    has: function (id) { return this.read().some(function (i) { return i.id == id; }); },

    init: function () {
      this.drawer = document.getElementById("WishlistDrawer");
      this.overlay = document.getElementById("WishlistOverlay");

      var self = this;
      document.querySelectorAll("[data-wishlist-open]").forEach(function (b) {
        b.addEventListener("click", function () { self.open(); });
      });
      document.querySelectorAll("[data-wishlist-close]").forEach(function (b) {
        b.addEventListener("click", function () { self.close(); });
      });
      if (this.overlay) this.overlay.addEventListener("click", function () { self.close(); });

      // botões de coração nos cards (delegação)
      document.addEventListener("click", function (e) {
        var btn = e.target.closest ? e.target.closest("[data-wishlist-toggle]") : null;
        if (!btn) return;
        e.preventDefault();
        self.toggle({
          id: btn.getAttribute("data-id"),
          title: btn.getAttribute("data-title"),
          url: btn.getAttribute("data-url"),
          image: btn.getAttribute("data-image"),
          price: btn.getAttribute("data-price")
        }, btn);
      });

      this.refreshButtons();
      this.updateCount();
    },

    toggle: function (item, btn) {
      var list = this.read();
      var idx = list.findIndex(function (i) { return i.id == item.id; });
      if (idx > -1) { list.splice(idx, 1); }
      else { list.push(item); }
      this.write(list);
      this.updateCount();
      this.refreshButtons();
      if (this.drawer && this.drawer.classList.contains("is-open")) this.render();
    },

    updateCount: function () {
      var n = this.read().length;
      document.querySelectorAll("[data-wishlist-count]").forEach(function (el) {
        el.textContent = n;
        el.style.display = n === 0 ? "none" : "";
      });
    },

    refreshButtons: function () {
      var self = this;
      document.querySelectorAll("[data-wishlist-toggle]").forEach(function (b) {
        b.classList.toggle("is-active", self.has(b.getAttribute("data-id")));
      });
    },

    open: function () {
      if (!this.drawer) return;
      this.render();
      this.drawer.classList.add("is-open");
      if (this.overlay) this.overlay.classList.add("is-open");
      document.body.style.overflow = "hidden";
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove("is-open");
      if (this.overlay) this.overlay.classList.remove("is-open");
      document.body.style.overflow = "";
    },

    render: function () {
      var box = document.getElementById("WishlistItems");
      if (!box) return;
      var list = this.read();
      if (!list.length) {
        box.innerHTML = '<div class="cart-empty"><p>Sua lista de desejos está vazia.</p></div>';
        renderIcons(); return;
      }
      var html = list.map(function (i) {
        return '<div class="cart-line">' +
          (i.image ? '<img src="' + i.image + '" alt="" width="64" height="80">' : '<span></span>') +
          '<div><a href="' + i.url + '" class="cart-line__title">' + (i.title || "Produto") + '</a>' +
          '<div class="cart-line__meta">' + (i.price || "") + '</div></div>' +
          '<button class="icon-btn" data-wishlist-toggle data-id="' + i.id + '" aria-label="Remover" style="color:var(--c-crimson)"><i data-lucide="trash-2" class="icon" style="width:20px;height:20px"></i></button>' +
          '</div>';
      }).join("");
      box.innerHTML = html;
      renderIcons();
    }
  };
  window.Wishlist = Wishlist;
})();
